import { gql } from '@apollo/client'

export const BRAND_HISTORY = gql`
  query BrandHistoryQuery($input: BrandHistoryInput!) {
    brandHistory(input: $input) {
      brandHistories {
        brand {
          name
        }
        historicalRelevancyList {
          relevancyScore
          date
        }
      }
    }
  }
`
